import * as React from "react"
import formikCode from "./codeExamples/formikCode"
import reactHookFormCode from "./codeExamples/reactHookFormCode"
import reduxFormCode from "./codeExamples/reduxFormCode"
import CodeArea from "./CodeArea"
import { AnimateGroup, Animate } from "react-simple-animate"
import colors from "../styles/colors"
import home from "../data/home"
import typographyStyles from "../styles/typography.module.css"
import containerStyles from "../styles/container.module.css"
import styles from "./CodeCompareSection.module.css"
import { useStateMachine } from "little-state-machine"
import copyClipBoard from "./utils/copyClipBoard"
import generic from "../data/generic"
import codeAreaStyles from "./CodeArea.module.css"
import getStartedWithExamplesContent from "../data/getStartedWithExamples"
import formFieldsStyles from "./FormFields.module.css"
const getStartedEn = getStartedWithExamplesContent["en"]

const errorStyle = {
  border: `1px solid ${colors.secondary}`,
  background: colors.errorPink,
  borderLeft: `10px solid ${colors.lightPink}`,
}

const props = {
  start: { transform: "translateY(100px)" },
  end: { transform: "translateY(0)" },
  easeType: "ease-in",
}

function CodeCompareSection({
  isPlayCodeCompare,
  currentLanguage,
}: {
  isPlayCodeCompare: boolean
  currentLanguage: string
}) {
  const [showFullScreen, setFullScreen] = React.useState(false)
  const [example, setExample] = React.useState('basic-css')

  const { state } = useStateMachine()
  const lightMode = state?.setting?.lightMode
  const getStarted = getStartedWithExamplesContent[currentLanguage]
  
  const handleOnChange = (event) => {
    setExample(event.target.value)
  }

  return (
    <AnimateGroup play={isPlayCodeCompare}>
      <div
        style={{
          marginBottom: 40,
        }}
      >
        <div className={containerStyles.centerContent}>
          <h1 className={typographyStyles.h1}>
            {/* {home.usage[currentLanguage].title} */}
            {getStarted.install.title}
          </h1>

          <p>
            {getStarted.install.description1}
          </p>

          <p
            id="codeComparison"
            className={styles.codeComparison}
            style={{ marginTop: 20}}
          >
            <select
              style={{
                width: '100%',
                ...errorStyle,
                paddingLeft: 10,
                height: 50,
              }}
              onChange={handleOnChange}
            >
              <option value="basic-css">Basic css</option>
              <option value="with-typescript">TypeScript</option>
              <option value="with-next-css">Next css</option>
              <option value="with-next-sass">Next sass</option>
              <option value="with-next-less">Next less</option>
              <option value="with-next-routes">Next routes</option>
              <option value="with-redux">Redux</option>
              <option value="with-redux-wrapper">Redux wrapper</option>
              <option value="with-redux-saga">Redux saga</option>
              <option value="with-apollo-and-redux">Apollo and redux</option>
              <option value="with-apollo-and-redux-saga">Apollo and redux saga</option>
              <option value="with-relay-modern">Replay modern</option>
              <option value="with-relay-modern-server-express">Replay modern and express server</option>
            </select>
          </p>

          <div style={{ marginTop: 30 }}>
            <p>{getStarted.install.description2}</p>
            <p id="codeComparison" className={styles.codeComparison}>
              <span
                className={`${styles.installCode} ${
                  lightMode ? styles.lightInstallCode : ""
                }`}
              >
                create-next-app my-app --example {example}
                <button
                  className={styles.copyButton}
                  onClick={() => {
                    copyClipBoard(`create-next-app my-app --example ${example}`)
                    alert(generic.copied[currentLanguage])
                  }}
                >
                  <span className={codeAreaStyles.copyIcon}>
                    <span />
                  </span>{" "}
                  {generic.copy[currentLanguage]}
                </button>
              </span>
            </p>
          </div>
        </div>
      </div>
    </AnimateGroup>
  )
}

export default React.memo(CodeCompareSection)
